import { Box, Divider, Stack } from '@mui/material';
import { FC } from 'react';
import LinkBarItem from '../link-bar-item';
import { useNavigate } from '@tanstack/react-router';
import useFeature from '@/hooks/use-feature.hook';
import Accordion from './accordion';
import NewChatButton from '../new-chat-button';
import useThread from '@/hooks/use-thread.hook';
import { TAB_ID } from '../helpers';

interface Props {
  open: boolean;
  onClick: () => void;
  onClickTab: (tabId: TAB_ID) => void;
  activeTab: TAB_ID;
  linkBarOpen: boolean;
}

const ChatLinkBarSection: FC<Props> = ({ open, onClick, onClickTab, activeTab, linkBarOpen }) => {
  const navigate = useNavigate();
  const { loadThread } = useThread();
  const { canViewHistory } = useFeature();

  const handleNewThread = () => {
    loadThread();
  };

  const handleClick = () => {
    navigate({ to: '/chat' });
    onClick();
  };

  return (
    <Box width="100%">
      <LinkBarItem
        icon="ai-chat"
        label="Chat"
        onClick={handleClick}
        primary={true}
        active={open}
        border={!open}
        hideLabel={!linkBarOpen}
      />

      <Accordion open={open}>
        {canViewHistory && (
          <LinkBarItem
            icon="history"
            label="History"
            onClick={() => onClickTab('history')}
            active={activeTab === 'history'}
            hideLabel={!linkBarOpen}
          />
        )}

        <LinkBarItem
          icon="assistant"
          label="Assistants"
          onClick={() => onClickTab('agents')}
          active={activeTab === 'agents'}
          hideLabel={!linkBarOpen}
        />

        <LinkBarItem
          icon="shortcut"
          label="Shortcuts"
          onClick={() => onClickTab('shortcuts')}
          active={activeTab === 'shortcuts'}
          hideLabel={!linkBarOpen}
        />

        <LinkBarItem
          icon="settings"
          label="Settings"
          onClick={() => onClickTab('user-settings')}
          active={activeTab === 'user-settings'}
          hideLabel={!linkBarOpen}
        />

        <Stack alignItems="center" width="100%">
          <Box width="100%">
            <Divider orientation="horizontal" />
          </Box>

          <Stack p="10px" width="100%" height="70px" justifyContent="center">
            <NewChatButton onClick={handleNewThread} hideLabel={!linkBarOpen} />
          </Stack>
        </Stack>
      </Accordion>
    </Box>
  );
};

export default ChatLinkBarSection;
